import {configureStore} from '@reduxjs/toolkit';
import {antiWebHook} from './AntiWebHook';
import {antiSpam} from './AntiSpam';
import {antiNuke} from './AntiNuke';
import {antiRaid} from './AntiRaid';
import {verification} from './Verification';
import {detection} from './Detection';
import {changeDetected} from './ChangeDetected';
import {changeAdvanceDetected} from './ChangeAdvanceDetected';
import {members} from './Members';
import {channels} from './Channels';
import {overview} from './Overview';
import {serverId} from './CurrentServerId';
import {changeBan} from './ChangeBan';
import {guilds} from './GuildsStore';
import {roles} from './Roles';
import {settings} from './Settings';
import {currentUser} from './CurrentUser';
import {allLogs} from './Logs';

export default configureStore({
  reducer: {
    guilds,
    currentUser,
    allLogs,
    antiWebHook,
    antiSpam,
    antiNuke,
    antiRaid,
    verification,
    detection,
    changeDetected,
    changeAdvanceDetected,
    members,
    roles,
    channels,
    overview,
    serverId,
    changeBan,
    settings,
  },
});
